import { createSlice } from "@reduxjs/toolkit";
import { ProposalInformationInterface } from "../../../components/Applications/ProposalInformationForm";

const initialState: ProposalInformationInterface = {
  proposerName: "",
  proposerEmail: "",
  propertyAddress: "",
  propertyCity: "",
  propertyState: "Select",
  propertyZipCode: "",
  developmentCost: 0,
  acquisitionType: "Select",
  constructionType: "Select",
  dealType: "Select",
  proposalInformationIsValid: false,
};

export const proposalInformationSlice = createSlice({
  name: "proposalInformation",
  initialState,
  reducers: {
    clearProposalInformation: () => initialState,
    setProposalInformation(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setProposalInformation, clearProposalInformation } =
  proposalInformationSlice.actions;

export default proposalInformationSlice.reducer;
